import React from 'react';
import { BlockStack, Card, InlineStack, Text } from '@shopify/polaris';
import { BUNDLE_APPS } from './config';
import AppChip from './AppChip';

interface ICoBenefitBannerProps {
  appStates: { paypal: boolean; returns: boolean };
}

const COMBOS = {
  paypal: {
    headline: 'Tracking synced, disputes blocked',
    body: "Customers see their tracking — PayPal sees it too. Fulfilled orders stay fulfilled instead of turning into disputes.",
    apps: [BUNDLE_APPS[0], BUNDLE_APPS[1]],
  },
  returns: {
    headline: 'From first delivery to easy returns',
    body: 'The full post-purchase journey handled in one stack — delivery notifications and seamless returns.',
    apps: [BUNDLE_APPS[0], BUNDLE_APPS[2]],
  },
  both: {
    headline: 'The complete post-purchase stack',
    body: "Customers always know where their order is, payments don't get disputed, and returns don't cost you the relationship.",
    apps: BUNDLE_APPS,
  },
};

const CoBenefitBanner = ({ appStates }: ICoBenefitBannerProps) => {
  const { paypal, returns } = appStates;
  if (!paypal && !returns) return null;

  const key = paypal && returns ? 'both' : paypal ? 'paypal' : 'returns';
  const { headline, body, apps } = COMBOS[key];

  return (
    <Card background="bg-surface-info">
      <BlockStack gap="200">
        <InlineStack gap="150" blockAlign="center">
          {apps.map((app, i) => (
            <React.Fragment key={app.id}>
              <AppChip color={app.color} letter={app.letter} label={app.name} logo={app.logo} size={22} />
              {i < apps.length - 1 && (
                <Text variant="bodySm" tone="subdued" as="span">
                  +
                </Text>
              )}
            </React.Fragment>
          ))}
        </InlineStack>
        <Text variant="headingSm" as="p">
          {headline}
        </Text>
        <Text variant="bodySm" tone="subdued" as="p">
          {body}
        </Text>
      </BlockStack>
    </Card>
  );
};

export default CoBenefitBanner;
